import { ChatIcon, Base } from '@itsrever/design-system'
import { PromocodeSummary } from '@/ui/components/process-details/process-island/summary-tab/promocode-summary'
import { ExchangeSummary } from '@/ui/components/process-details/process-island/summary-tab/exchange-summary'
import { useTranslation } from 'react-i18next'

const { Card } = Base

interface CompensationIslandProps {
  promoCode: string
  giftCardCode: string
  exchangeOrderNumber: string
  exchangeOrderUrl?: string
  isInstantExchange: boolean
}

const CompensationIsland: React.FC<CompensationIslandProps> = ({
  promoCode,
  giftCardCode,
  exchangeOrderNumber,
  exchangeOrderUrl,
  isInstantExchange
}) => {
  const { t } = useTranslation()

  return (
    <>
      {promoCode || giftCardCode || exchangeOrderNumber ? (
        <Card className="h-fit p-4">
          <div className="flex flex-wrap items-center justify-between gap-3 pb-3">
            <div className="flex items-center gap-1.5">
              <ChatIcon className="size-5 text-primary-main" />
              <p className="text-sm font-semibold">
                {t('summary.compensation')}
              </p>
            </div>
            {exchangeOrderNumber && isInstantExchange ? (
              <div
                title={t('cost_type.INSTANT_EXCHANGE')}
                className="font-logo h-fit rounded-md bg-[#1790ff] px-2 py-1 text-xs uppercase italic tracking-wide text-white"
              >
                {t('summary.instant')}
              </div>
            ) : null}
          </div>
          <div className="space-y-3">
            {promoCode || giftCardCode ? (
              <PromocodeSummary
                promoCode={promoCode}
                giftCardCode={giftCardCode}
              />
            ) : null}
            {exchangeOrderNumber ? (
              <ExchangeSummary
                newOrderId={exchangeOrderNumber}
                orderUrl={exchangeOrderUrl}
              />
            ) : null}
          </div>
        </Card>
      ) : null}
    </>
  )
}

export default CompensationIsland
